import React, { Component } from "react";
import { connect } from "react-redux";
import Reaptcha from "reaptcha";

// Components
import Loader from "../utils/Loader";

// State
import { getCustomerLoginToken, customerLogin, clearErrors } from "../../store/actions/user";
import { REACT_APP_RECAPTCHA_KEY } from "../../shared/vars";

// CSS
import "../../css/errors-success.css";

class LoginForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			password: "",
			recaptchaLoaded: false
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	// ===================================
	//  LIFE CYCLE METHOD
	// ===================================
	componentDidMount() {
		window.addEventListener("beforeunload", this.componentCleanup);
		if (this.props.persisted) {
			this.performTokenSetup();
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.persisted === true && this.props.persisted === false) {
			this.performTokenSetup();
		}

		if (nextProps.maxLoginsReached !== this.props.maxLoginsReached) {
			this.setState({
				recaptchaLoaded: false
			});
		}

		return true;
	}

	performTokenSetup() {
		this.props.getCustomerLoginToken();

		if (!this.props.maxLoginsReached) {
			this.setState({ recaptchaLoaded: true });
		}
	}

	componentCleanup() {
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		this.componentCleanup();
	}

	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	recaptchChanged(value) {
		this.setState({
			recaptcha: value
		});
	}

	setRecaptchaLoaded(e) {
		this.setState({
			recaptchaLoaded: true
		});
	}

	// ===================================
	//  SUBMIT
	// ===================================
	handleSubmit(event) {
		event.preventDefault();

		if (this.props.maxLoginsReached && !this.state.recaptcha) {
			return;
		}

		this.props
			.customerLogin(this.state.email, this.state.password, this.state.recaptcha)
			.catch(() => {
				// Reset recaptcha
				// console.log(this.captcha, this.state.recaptchaLoaded);
				if (this.captcha && this.state.recaptchaLoaded) {
					this.captcha.reset();
					this.setState({ recaptcha: null });
				}
			});
	}

	// ===================================
	//  RENDER
	// ===================================
	render() {
		const showRecaptch = this.props.maxLoginsReached;

		return (
			<form className="centered-form">
				{this.props.loginTokenLoading ? (
					<Loader />
				) : (
					<div>
						<div className="form-field no-label-field">
							<label htmlFor="email">Email:</label>

							{this.props.errors.email && (
								<div className="error msg_animate">{this.props.errors.email}</div>
							)}
							<input
								type="email"
								name="email"
								value={this.state.email}
								placeholder="email@provider.com"
								onKeyPress={e => this.handleKeyPress(e)}
								onChange={e => this.handleInputChange(e)}
							/>
						</div>

						<div className="form-field no-label-field">
							<label htmlFor="password">Password:</label>

							{this.props.errors.password && (
								<div className="error msg_animate">
									{this.props.errors.password}
								</div>
							)}
							<input
								type="password"
								name="password"
								value={this.state.password}
								placeholder=""
								onKeyPress={e => this.handleKeyPress(e)}
								onChange={e => this.handleInputChange(e)}
							/>
						</div>

						{showRecaptch && (
							<Reaptcha
								ref={e => (this.captcha = e)}
								sitekey={REACT_APP_RECAPTCHA_KEY}
								onVerify={value => this.recaptchChanged(value)}
								onLoad={() => this.setRecaptchaLoaded()}
							/>
						)}

						<div className="btn_container">
							{this.props.errors.general && (
								<div className="error msg_animate">{this.props.errors.general}</div>
							)}
							<button
								className="btn submit-btn"
								name="submit"
								value="submit"
								onClick={e => this.handleSubmit(e)}
							>
								<span>Log In</span>
							</button>
						</div>
					</div>
				)}
			</form>
		);
	}
}

const mapStateToProps = state => {
	return {
		persisted: state.persist,
		errors: state.user.errors,
		loginTokenLoading: state.user.loginTokenLoading,
		maxLoginsReached: !!state.user.maxLoginsReached.customer
			? state.user.maxLoginsReached.customer
			: false
	};
};

export default connect(
	mapStateToProps,
	{ getCustomerLoginToken, customerLogin, clearErrors }
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/customer/LoginForm.js